// frontend/src/pages/admin/lcl/utils/montantTtc.js
// Miroir du helper backend (backend/src/utils/lcl/montantTtc.js).
// invoices.montant_facture est HT en BDD ; les prélèvements LCL (CSV + CFONB)
// portent sur le TTC. L'UI affiche donc TTC pour rester cohérente avec
// la facture envoyée au client.

export const TVA_RATE = 0.20;

export function montantTtc(montantHt) {
  const ht = Number(montantHt) || 0;
  return Math.round(ht * (1 + TVA_RATE) * 100) / 100;
}
